module.exports = __webpack_public_path__ + "static/media/jollyLube.9c4033f8.png";